module.exports = __webpack_public_path__ + "static/0003-d69e0f7f703df9251c2120a5bf734151.png";